<template>
	<div class="order-body">
    <ul class="store-setting-header">
			<span>
				<i class="el-icon-back" @click="goBack"></i>
			</span>
			<li>提现明细</li>
		</ul>
		<div class="detail-header">
			<div class="top-detail">
				<div style="margin: 0;">提现金额：￥{{cashOut.cashOutMoney}}</div>
				<div>明细订单数：{{detailCount}}单</div>
				<div>提现编号：{{cashOut.cashOutCode}}</div>
				<div>申请提现时间：{{cashOut.createDate}}</div>
				<div>审核时间：{{cashOut.reviewDate ? cashOut.reviewDate : '——'}}</div>
				<div>打款标记时间：{{cashOut.cashoutDate ? cashOut.cashoutDate : '———'}}</div>
			</div>
			<div class="btn-box" v-if="cashOut.cashOutStatus === 1">
				<el-button size="small" type="plain" class="btn fx-btn" v-if="AuthorityList['11_0004_0003_00']" @click="detaiHandleClick(0)">拒绝</el-button>
				<el-button size="small" type="primary" class="btn fx-btn" v-if="AuthorityList['11_0004_0003_00']" @click="detaiHandleClick(2)">同意</el-button>
			</div>
		</div>
		<div class="filters-box-row">
			<div class="filters-container">
				<div class="input-box">
					<span>单号：</span>
					<el-input
						class="search-input"
						v-model="orderNumber"
						placeholder="请输入订单编号"
						size="small"
						@keyup.enter.native="search">
					</el-input>
				</div>
			</div>
			<div class="filters-container">
				<div class="input-box">
					<span>客户名称：</span>
					<el-input
						class="search-input"
						v-model="customerName"
						placeholder="请输入客户名称、编号"
						size="small"
						@keyup.enter.native="search">
					</el-input>
				</div>
			</div>
			<div class="filters-container">
				<el-button size="small" type="primary" class="btn fx-btn" @click="search">查询</el-button>
				<el-button size="small" plain class="btn fx-btn" style="margin-left: 10px" @click="reset">清空</el-button>
			</div>
			<div class="batch-register-btn" @click="listExport">
				<i class="excel-icon import-excel-icon"/>
				<span>导出</span>
			</div>
		</div>
		<MainTable
			ref='table'
			:size='size'
			:page='page'
			:tableData='tableData'
			:totalCount='totalCount'
			:AuthorityList='AuthorityList'
			@sortSearch="sortSearch"
			@handleSize='handleSizeChange'
			@handlePage='handlePageChange'
		/>
	</div>
</template>

<script>
// import Search from '@/components/percentage/Search.vue'
import MainTable from '@/components/withdrawalReviewDetail/MainTable.vue'
export default {
	name: 'withdrawalReviewDetail',
	components: {
		MainTable
	},
	data () {
		return {
			AuthorityList: {
				'11_0004_0001_00': false,
				'11_0004_0002_00': false,
				'11_0004_0003_00': false
			},
			orderNumber: '',
			customerName: '',
			page: 1,
			size: 20,
			cashOut: {},
			tableData: [],
			totalCount: 0,
			customList: [],
			staff: [],
			orderKey: '',
			orderBy: '',
			params: {},
			detailCount: 0
		}
	},
	created () {
		this.$fxEventBus.$emit('setMenu', '13-3')
		this.getAuthority('11_0004_0000_00')
		this.openPage()
	},
	methods: {
		listExport () {
			let params = this.params
			params.orderKey = this.orderKey
			params.orderBy = this.orderBy
			params.cashOutId = this.cashOutId
			params.number = this.orderNumber
			params.customer = this.customerName
			const req = new XMLHttpRequest()
			let _this = this
			req.open('POST', `${this.$fxBaseApi.newExportUrl}/commission/cashoutdetail/exportExcel`, true)
			req.responseType = 'blob'
			req.setRequestHeader('Content-Type', 'application/json')
			req.setRequestHeader('pname', 'bc2ff5388144d30e137b28acafd39795')
			req.setRequestHeader('shiroSession', window.sessionStorage.getItem('shiroSession'))
			req.onload = function () {
				const data = req.response
				const blob = new Blob([data])
				const blobUrl = window.URL.createObjectURL(blob)
				_this.download(blobUrl)
			}
			req.send(JSON.stringify(params))
		},
		download (blobUrl) {
			const a = document.createElement('a')
			a.style.display = 'none'
			let name = ''
			name = '提现审核结果.xls'
			name = name.replace(/:/g, '：')
			a.download = name
			a.href = blobUrl
			a.click()
		},
		goBack () {
			window.sessionStorage.removeItem('withdrawalReviewId')
			this.$router.push('/main/withdrawalReview')
		},
		getAuthority (data) {
			let params = {
				pId: data
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/authority/getUserAuthority`,
				data: params
			}).then(res => {
				if (res.result === true) {
					let a = res.data
					for (let i = 0; i < a.length; i++) {
						this.AuthorityList[a[i]] = true
					}
				}
			})
		},
		// 客户类别
		getCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customerCategory/list`
			}).then(res => {
				if (res.result === true) {
					this.customList = res.data.childNode
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		openPage () {
			this.findCashoutdetail()
		},
		handleSizeChange (value) {
			this.size = value
			this.page = 1
			this.findCashoutdetail()
		},
		handlePageChange (value) {
			this.page = value
			this.findCashoutdetail()
		},
		reset () {
			this.orderNumber = ''
			this.customerName = ''
			this.findCashoutdetail()
		},
		search () {
			this.findCashoutdetail()
		},
		sortSearch (data) {
			this.orderKey = data.orderKey
			this.orderBy = data.orderBy
			this.findCashoutdetail()
		},
		findCashoutdetail () {
			this.tableData = []
			this.cashOutId = window.sessionStorage.getItem('withdrawalReviewId')
			let params = {
				cashOutId: this.cashOutId,
				number: this.orderNumber,
				customer: this.customerName,
				orderKey: this.orderKey,
				orderBy: this.orderBy
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/commission/cashoutdetail`,
				data: params
			}).then(res => {
				if (res.result) {
					this.totalCount = res.data.recordCount
					this.tableData = res.data.detailList
					this.detailCount = res.data.detailCount
					if (!(String(res.data.cashOut.cashOutMoney).indexOf('.') !== -1 && String(res.data.cashOut.cashOutMoney).split('.')[1].length > 2)) {
						res.data.cashOut.cashOutMoney = this.$fxUtils.toFixedSHW(res.data.cashOut.cashOutMoney, 2)
					}
					this.tableData.forEach(item => {
						if (!(String(item.realpaymoney).indexOf('.') !== -1 && String(item.realpaymoney).split('.')[1].length > 2)) {
							item.realpaymoney = this.$fxUtils.toFixedSHW(item.realpaymoney, 2)
						}
						if (!(String(item.returnmoney).indexOf('.') !== -1 && String(item.returnmoney).split('.')[1].length > 2)) {
							item.returnmoney = this.$fxUtils.toFixedSHW(item.returnmoney, 2)
						}
					})
					this.cashOut = res.data.cashOut
					this.$nextTick(() => {
						this.$refs.table.initIschoose()
					})
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		detaiHandleClick (num) {
			let params = {
				cashOutStatus: num,
				cashOutIds: this.cashOutId
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/commission/cashout/cashoutstatus`,
				data: params
			}).then(res => {
				if (res.result) {
					this.$message.success(res.msg)
					this.$router.push('/main/withdrawalReview')
				} else {
					this.$message.error('处理失败，请稍后重试！')
				}
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.order-body {
	flex: 1
	display flex
	flex-direction column
	.store-setting-header {
		border-bottom: 1px solid #dce2fd;
		height:50px;
		line-height: 50px;
		font-size: 18px;
		box-sizing border-box
		span {
			float left
			display inline-block
			line-height 50px
			padding-right 20px
			i {
				border-radius: 50%;
				cursor: pointer;
				background: #9da6af;
				padding: 3px;
			}
			.el-icon-back {
				content: "\E6EA";
				color: #fff;
				font-weight: bold;
			}
		}
		li {
			margin-right 40px
			height: 100%
			box-sizing:border-box
			float left
		}
	}
	.detail-header {
		display: flex;
    flex-flow: row;
		flex-wrap: wrap;
		align-items: center;
		justify-content: space-between
    font-size: 16px;
    font-weight: bold;
		padding: 20px 0;
		.top-detail {
			display: flex;
			flex-flow: row;
			flex-wrap: wrap;
			div {
				margin-left: 40px
			}
		}
	}
	.filters-box-row {
		display: flex;
		align-items: center;
		padding: 10px 0 0 0;
		width :100%;
		line-height :50px;
		min-width :600px;
		box-sizing: border-box
		text-align: left
		.select-input {
			width: 125px!important;
		}
		.filters-container {
			margin-right: 5px
			.el-input {
				width: 155px
			}
			.time-input {
				width: 310px;
				margin-left: 10px;
			}
			.filter-input {
				width: 155px
			}
			.excel-icon {
				display inline-block
				height 20px
				width 20px
				background-repeat no-repeat
				background-position center
				vertical-align: sub;
				&.import-excel-icon {
					background-image: url('~images/icon/import-excel-icon.png')
				}
				&.export-excel-icon {
					background-image: url('~images/icon/export-excel-icon.png')
				}
			}
		}
	}
	.batch-register-btn{
		cursor :pointer;
		color: var(--fx-primary-color);
		font-size: 12px;
		margin-left: 10px;
		display: flex;
		width: 100px;
		height: 32px;
		justify-content center;
		align-items center;
	}
	.excel-icon {
		display inline-block
		height 20px
		width 20px
		background-repeat no-repeat
		background-position center
		&.import-excel-icon {
			background-image: url('~images/icon/import-excel-icon.png')
		}
		&.export-excel-icon {
			background-image: url('~images/icon/export-excel-icon.png')
		}
	}
}
</style>
<style lang="stylus">
.order-body {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
